/**
 * Collection bundle builder — native build of the Intelligems "PLP | Bundle Builder" winner (DEV-15208).
 *
 * Markup is server-rendered by sections/main-collection-product-grid.liquid and the bundle-builder-*
 * snippets: every card's Quick Add button, the device selectors and the Your Bundle bar exist before
 * this file runs. This file only adds behavior:
 *  - Quick Add (one delegated click handler, so a card can never miss its button): XHR /cart/add.js,
 *    no cart drawer, then a no-op /cart/update.js so the Style Club cart app refreshes and broadcasts.
 *  - Your Bundle bar: re-renders from the cart after every change, remove-one, mobile open/close.
 *  - Device selector: drives the theme's "Select Device" facet (facets.js).
 *  - Members-only cards listed by the Style Club app config (tagged ones are handled in Liquid).
 * The Buy 2 Get 2 discount itself is Shopify's automatic discount; this code only reads the cart.
 * Events keep the variation's names (window.igEvents) so reporting stays continuous.
 */
(() => {
  if (window.BundleBuilder) return;

  const DEVICE_NAME = 'filter.v.option.select device';
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const COPY = {
    quickAdd: 'Quick Add',
    added: 'Added ✓',
    soldOut: 'Sold Out',
    error: "Couldn't add this case. Please try again.",
    empty: 'Add 2 Cases, Get 2 Extra Free',
    viewCart: 'View Cart',
    free: 'FREE',
    allDevices: 'All devices',
  };
  const ICON = {
    add: '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M13.6563 2.34375C12.1487 0.879657 10.1256 0.0675355 8.02422 0.0828934C5.92279 0.0982512 3.9118 0.939855 2.42583 2.42583C0.939855 3.9118 0.0982512 5.92279 0.0828934 8.02422C0.0675355 10.1256 0.879657 12.1487 2.34375 13.6563C3.85128 15.1203 5.87436 15.9325 7.97579 15.9171C10.0772 15.9018 12.0882 15.0601 13.5742 13.5742C15.0601 12.0882 15.9018 10.0772 15.9171 7.97579C15.9325 5.87436 15.1203 3.85128 13.6563 2.34375Z" fill="#000"/><path d="M8 3.55a.47.47 0 0 1 .47.47v3.51h3.51a.47.47 0 1 1 0 .94H8.47v3.51a.47.47 0 1 1-.94 0V8.47H4.02a.47.47 0 1 1 0-.94h3.51V4.02A.47.47 0 0 1 8 3.55Z" fill="#fff"/></svg>',
    trash: '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M6.57143 3.42857H9.42857C9.42857 3.04969 9.27806 2.68633 9.01015 2.41842C8.74224 2.15051 8.37888 2 8 2C7.62112 2 7.25776 2.15051 6.98985 2.41842C6.72194 2.68633 6.57143 3.04969 6.57143 3.42857ZM5.71429 3.42857C5.71429 2.82236 5.9551 2.24098 6.38376 1.81233C6.81241 1.38367 7.39379 1.14286 8 1.14286C8.60621 1.14286 9.18759 1.38367 9.61624 1.81233C10.0449 2.24098 10.2857 2.82236 10.2857 3.42857H13.8571C13.9708 3.42857 14.0798 3.47372 14.1602 3.5541C14.2406 3.63447 14.2857 3.74348 14.2857 3.85714C14.2857 3.97081 14.2406 4.07982 14.1602 4.16019C14.0798 4.24056 13.9708 4.28571 13.8571 4.28571H13.1086L12.4131 12.6303C12.3625 13.2373 12.0857 13.8032 11.6374 14.2157C11.1892 14.6281 10.6023 14.8571 9.99314 14.8571H6.00686C5.39771 14.8571 4.81082 14.6281 4.36257 14.2157C3.91433 13.8032 3.63745 13.2373 3.58686 12.6303L2.89143 4.28571H2.14286C2.02919 4.28571 1.92018 4.24056 1.83981 4.16019C1.75944 4.07982 1.71429 3.97081 1.71429 3.85714C1.71429 3.74348 1.75944 3.63447 1.83981 3.5541C1.92018 3.47372 2.02919 3.42857 2.14286 3.42857H5.71429ZM6.85714 6.71429a.4286.4286 0 0 0-.85714 0v5.14285a.4286.4286 0 0 0 .85714 0V6.71429Zm2.28572 0a.4286.4286 0 0 1 .85714 0v5.14285a.4286.4286 0 0 1-.85714 0V6.71429Z" fill="currentColor"/></svg>',
  };

  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const money = (cents) => `$${(cents / 100).toFixed(2)}`;
  const shortTitle = (t) => String(t).replace(/\s+(iPhone|Samsung|Galaxy|Pixel|Kindle|AirPods?)?\s*Case$/i, '').trim();
  const sized = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track = (event) => {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event });
  };
  const readJSON = (id) => {
    try {
      return JSON.parse(document.getElementById(id)?.textContent || 'null');
    } catch (err) {
      return null;
    }
  };
  const store = {
    get(k) {
      try { return sessionStorage.getItem(k) || ''; } catch (err) { return ''; }
    },
    set(k, v) {
      try { sessionStorage.setItem(k, v); } catch (err) { /* private mode */ }
    },
  };
  const appPresent = () => !!document.getElementById('bsc-cart-drawer-config');
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------------- Cart ---------------- */
  const state = {
    sig: '',
    units: [],
    count: 0,
    orig: 0,
    fin: 0,
    busy: new Set(),
    queue: Promise.resolve(),
    pullTimer: 0,
    seeded: false,
    lastSync: 0,
  };
  let tray = null;

  const isCartShape = (d) => !!d && Array.isArray(d.items) && typeof d.item_count === 'number';

  const addonIds = () => {
    const ids = new Set((tray?.dataset.addonIds || '').split(',').filter(Boolean).map(Number));
    const rt = readJSON('bsc-cart-drawer-runtime');
    const cfg = readJSON('bsc-cart-drawer-config');
    [rt?.membershipVariantId, rt?.memberAddons?.gift?.variantId, cfg?.shippingProtection?.variantId]
      .concat((rt?.memberAddons?.freebies || []).map((f) => f.variantId))
      .forEach((v) => { if (v) ids.add(Number(v)); });
    return ids;
  };
  const isAddon = (item, ids) => ids.has(item.variant_id) || item.handle === 'shippingprotection';

  const setCart = (cart, announce) => {
    if (!isCartShape(cart)) return;
    state.lastSync = Date.now();
    const sig = `${cart.item_count}|${cart.items.map((i) => `${i.key}:${i.quantity}:${i.final_line_price}`).join(',')}`;
    if (sig === state.sig) return;
    state.sig = sig;
    const ids = addonIds();
    const units = [];
    let orig = 0;
    let fin = 0;
    cart.items.filter((i) => !isAddon(i, ids)).reverse().forEach((i) => {
      orig += i.original_line_price;
      fin += i.final_line_price;
      const free = i.original_price > 0 ? Math.min(i.quantity, Math.floor((i.original_line_price - i.final_line_price) / i.original_price)) : 0;
      for (let n = 0; n < i.quantity; n++) {
        units.push({ key: i.key, title: shortTitle(i.product_title), image: i.featured_image?.url || i.image || '', free: n < free, qty: i.quantity });
      }
    });
    state.units = units;
    state.count = units.length;
    state.orig = orig;
    state.fin = fin;
    tray?.render(announce);
  };

  const getCart = () => (window.BSCCart?.get ? window.BSCCart.get() : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)));
  const pull = () => getCart().then((c) => { if (c) setCart(c); }).catch(() => {});
  const schedulePull = () => {
    clearTimeout(state.pullTimer);
    state.pullTimer = setTimeout(pull, 80);
  };

  const broadcast = (cart) => {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-builder', cartData: cart });
  };

  const ensureBubble = (count) => {
    const link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    let b = link.querySelector('.cart-count-bubble');
    if (!count) {
      b?.remove();
      return;
    }
    if (!b) {
      link.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true"></span><span class="visually-hidden"></span></div>');
      b = link.querySelector('.cart-count-bubble');
    }
    const v = b.querySelector('span[aria-hidden="true"]');
    if (v && count < 100) v.textContent = count;
    const h = b.querySelector('.visually-hidden');
    if (h) h.textContent = `${count} item${count === 1 ? '' : 's'}`;
    link.classList.remove('cart-icon-bubble--bump');
    requestAnimationFrame(() => link.classList.add('cart-icon-bubble--bump'));
  };

  // After an XHR add: let the Style Club app run its own refresh + broadcast via a no-op /cart/update.js
  // (a non-add request, so its drawer does not open). Without the app, broadcast ourselves.
  const syncAfterAdd = () => {
    window.BSCCart?.invalidate?.();
    if (appPresent()) {
      return window.fetch('/cart/update.js', { method: 'POST', headers: jsonHeaders, body: '{}' })
        .then((r) => (r.ok ? r.json() : null))
        .then((c) => { if (c) { setCart(c, true); ensureBubble(c.item_count); } return c; });
    }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((c) => { if (c) { setCart(c, true); ensureBubble(c.item_count); broadcast(c); } return c; });
  };

  // XHR rather than fetch: the Style Club cart app wraps fetch and opens its drawer on /cart/add.
  const xhrJSON = (method, url, body) => new Promise((resolve, reject) => {
    const x = new XMLHttpRequest();
    x.open(method, url);
    Object.keys(jsonHeaders).forEach((k) => x.setRequestHeader(k, jsonHeaders[k]));
    x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    x.onload = () => {
      let d = null;
      try { d = JSON.parse(x.responseText); } catch (err) { d = null; }
      if (x.status >= 200 && x.status < 300) resolve(d);
      else reject(Object.assign(new Error('cart'), { status: x.status, data: d }));
    };
    x.onerror = () => reject(new Error('network'));
    x.send(body ? JSON.stringify(body) : null);
  });

  /* ---------------- Quick Add ---------------- */
  const setBtn = (btn, mode) => {
    if (!btn) return;
    btn.classList.remove('bb-qa--added');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    if (mode === 'busy') btn.setAttribute('aria-busy', 'true');
    if (mode === 'soldout') {
      btn.disabled = true;
      btn.textContent = COPY.soldOut;
      return;
    }
    if (mode === 'added') {
      btn.classList.add('bb-qa--added');
      btn.textContent = COPY.added;
      clearTimeout(btn.bbTimer);
      btn.bbTimer = setTimeout(() => {
        btn.classList.remove('bb-qa--added');
        btn.textContent = COPY.quickAdd;
      }, 1200);
      return;
    }
    btn.textContent = COPY.quickAdd;
  };

  const showError = (btn, msg) => {
    const host = btn?.closest('.card__information') || btn?.parentElement;
    if (!host) return;
    host.querySelector('.bb-card-error')?.remove();
    host.insertAdjacentHTML('beforeend', `<p class="bb-card-error" role="alert">${esc(msg)}</p>`);
    const el = host.querySelector('.bb-card-error');
    setTimeout(() => el?.remove(), 5000);
  };

  const addVariant = (variantId, btn) => {
    if (state.busy.has(variantId)) return;
    state.busy.add(variantId);
    setBtn(btn, 'busy');
    track('plp_quick_add');
    state.queue = state.queue
      .then(() => xhrJSON('POST', '/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] }))
      .then(() => syncAfterAdd())
      .then(() => {
        setBtn(btn, 'added');
        tray?.onAdded();
      })
      .catch((err) => {
        const msg = err?.data?.description || err?.data?.message || COPY.error;
        setBtn(btn, /sold out|unavailable|inventory|stock/i.test(msg) ? 'soldout' : 'idle');
        showError(btn, msg);
        pull();
      })
      .then(() => state.busy.delete(variantId));
  };

  // Delegated on document: works for every server-rendered button, including cards that facets.js
  // swaps in after a filter change, with nothing to "decorate" per card.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.bb-qa[data-bb-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    addVariant(btn.dataset.bbVariant, btn);
  });
  // Belt and braces for a keyboard submit of the card form: same path, never a page post.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('.bb-qa-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.bb-qa[data-bb-variant]');
    if (btn && !btn.disabled && btn.getAttribute('aria-busy') !== 'true') addVariant(btn.dataset.bbVariant, btn);
  });

  /* ---------------- Members-only cards from the Style Club app config ---------------- */
  // Tagged products are handled in Liquid. The app can also list handles; those cards lose their
  // Quick Add and the first-row order is recomputed (same rule as the Liquid one).
  const Grid = {
    applyAppMembersOnly() {
      const handles = new Set((readJSON('bsc-members-card-atc-config')?.handles || []).map((h) => String(h).toLowerCase()));
      if (!handles.size) return;
      const ul = document.querySelector('#product-grid.bb-grid');
      if (!ul) return;
      const lis = [...ul.querySelectorAll(':scope > li.grid__item')];
      let changed = false;
      lis.forEach((li) => {
        if (li.classList.contains('bb-mo') || !handles.has((li.dataset.bbHandle || '').toLowerCase())) return;
        li.classList.add('bb-mo');
        li.querySelector('.bb-qa-form, .bb-qa')?.remove();
        changed = true;
      });
      if (!changed) return;
      let m = 0;
      let d = 0;
      lis.forEach((li) => {
        const mo = li.classList.contains('bb-mo');
        // Classes, not inline styles: animations.js rewrites the style attribute on reveal.
        li.classList.toggle('bb-late-m', !(!mo && m < 2));
        li.classList.toggle('bb-late-d', !(!mo && d < 4));
        if (!mo) { m += 1; d += 1; }
      });
    },
  };

  /* ---------------- Device selector ---------------- */
  const Device = {
    sig: '',
    busy: false,
    roots() {
      return [...document.querySelectorAll('[data-bb-device]')];
    },
    inputs() {
      const list = [...document.querySelectorAll(`#FacetFiltersForm input[name="${DEVICE_NAME}"]`)];
      return list.length ? list : [...document.querySelectorAll(`#FacetFiltersFormMobile input[name="${DEVICE_NAME}"]`)];
    },
    options() {
      return this.inputs().map((i) => ({
        value: i.value,
        label: i.closest('label')?.querySelector('.facet-checkbox__text-label')?.textContent.trim() || i.value,
        checked: i.checked,
      }));
    },
    // No device filter applied: show the device the cards are adding (first card's variant subtitle).
    current(opts) {
      const checked = opts.find((o) => o.checked);
      if (checked) return checked.value;
      const sub = document.querySelector('#product-grid .card-information__variant-subtitle')?.textContent.split('·')[0].trim().toLowerCase();
      const m = sub && opts.find((o) => o.value.toLowerCase() === sub);
      return m ? m.value : '';
    },
    markup(opts) {
      const groups = new Map();
      opts.forEach((o) => {
        const g = o.label.split(' ')[0];
        if (!groups.has(g)) groups.set(g, []);
        groups.get(g).push(o);
      });
      const opt = (o) => `<option value="${esc(o.value)}">${esc(o.label)}</option>`;
      return `<option value="">${COPY.allDevices}</option>${groups.size > 1
        ? [...groups].map(([g, list]) => `<optgroup label="${esc(g)}">${list.map(opt).join('')}</optgroup>`).join('')
        : opts.map(opt).join('')}`;
    },
    sync() {
      const roots = this.roots();
      if (!roots.length) return;
      const opts = this.options();
      if (!opts.length) return; // keep the server-rendered options
      const sig = opts.map((o) => o.value).join('|');
      const rebuild = this.sig && sig !== this.sig;
      this.sig = sig;
      const markup = rebuild ? this.markup(opts) : '';
      const value = this.current(opts);
      roots.forEach((root) => {
        const select = root.querySelector('select');
        if (rebuild) select.innerHTML = markup;
        select.value = value;
        select.disabled = false;
        root.removeAttribute('aria-busy');
      });
      this.busy = false;
    },
    apply(value) {
      track('plp_device_selected');
      const form = document.getElementById('FacetFiltersForm');
      const inputs = [...document.querySelectorAll(`input[name="${DEVICE_NAME}"]`)];
      if (!form || !inputs.length || !customElements.get('facet-filters-form')) {
        location.assign(`${location.pathname}${value ? `?filter.v.option.select+device=${encodeURIComponent(value).replace(/%20/g, '+')}` : ''}`);
        return;
      }
      inputs.forEach((i) => { i.checked = i.value === value; });
      this.busy = true;
      this.roots().forEach((root) => {
        const select = root.querySelector('select');
        select.value = value;
        select.disabled = true;
        root.setAttribute('aria-busy', 'true');
      });
      form.dispatchEvent(new Event('input', { bubbles: true }));
      setTimeout(() => { if (this.busy) this.sync(); }, 8000);
    },
    init() {
      document.addEventListener('change', (e) => {
        const select = e.target.closest?.('[data-bb-device-select]');
        if (select) this.apply(select.value);
      });
      this.sync();
    },
  };

  /* ---------------- Your Bundle bar ---------------- */
  class BundleBuilderTray extends HTMLElement {
    connectedCallback() {
      // Fixed bar: live on <body>, clear of any transformed/animated ancestor in the section.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this.mounted) return;
      this.mounted = true;
      tray = this;
      const q = (s) => this.querySelector(s);
      this.head = q('.bb-tray__head');
      this.toggleBtn = q('.bb-tray__toggle');
      this.countEl = q('.bb-tray__count');
      this.segs = [...this.querySelectorAll('.bb-tray__seg')];
      this.slots = q('.bb-slots');
      this.origEl = q('.bb-tray__orig');
      this.finEl = q('.bb-tray__fin');
      this.summary = q('.bb-tray__summary');
      this.live = q('.bb-tray__live');
      this.progress = q('.bb-tray__progress');
      this.scrollThumb = q('.bb-scroll__thumb');
      this.scrollTrack = q('.bb-scroll');
      this.open = false;
      document.documentElement.classList.add('bb-tray-on');

      this.slots.addEventListener('scroll', () => this.syncScroll(), { passive: true });
      this.head.addEventListener('click', (e) => {
        if (DESKTOP.matches) return;
        e.preventDefault();
        this.setOpen(!this.open, true);
      });
      this.addEventListener('click', (e) => {
        const rm = e.target.closest('.bb-slot__rm');
        if (!rm) return;
        const unit = state.units.find((u) => u.key === rm.dataset.key);
        if (unit) this.decrement(unit, rm.closest('.bb-slot'));
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.open && !DESKTOP.matches) this.setOpen(false, true);
      });
      document.addEventListener('click', (e) => {
        if (this.open && !DESKTOP.matches && !e.target.closest('.bb-tray')) this.setOpen(false);
      });
      // Capture phase: the Style Club app's own capture handler stops propagation on /cart links.
      document.addEventListener('click', (e) => {
        if (!e.target.closest?.('.bb-cta[href]')) return;
        track('bundle_view_cart');
        if (!DESKTOP.matches) this.setOpen(false);
      }, true);

      this.setOpen(store.get('bb-tray') === 'open');
      if ('ResizeObserver' in window) new ResizeObserver(() => { this.spacer(); this.syncScroll(); }).observe(this);
      DESKTOP.addEventListener('change', () => { this.spacer(); this.syncScroll(); });
      this.spacer();
      this.syncScroll();
    }

    decrement(unit, slotEl) {
      if (state.busy.has(unit.key)) return;
      state.busy.add(unit.key);
      slotEl?.setAttribute('aria-busy', 'true');
      track('bundle_item_removed');
      state.queue = state.queue
        .then(() => window.fetch('/cart/change.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ id: unit.key, quantity: unit.qty - 1 }) }))
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('change'))))
        .then((c) => {
          window.BSCCart?.invalidate?.();
          setCart(c, true);
          ensureBubble(c.item_count);
          if (!appPresent()) broadcast(c);
        })
        .catch(() => pull())
        .then(() => state.busy.delete(unit.key));
    }

    syncScroll() {
      const ul = this.slots;
      const max = ul.scrollWidth - ul.clientWidth;
      const scrollable = max > 1;
      this.classList.toggle('bb-tray--scrollable', scrollable);
      if (!scrollable) return;
      const trackW = this.scrollTrack.clientWidth;
      const w = Math.max(20, Math.round((trackW * ul.clientWidth) / ul.scrollWidth));
      this.scrollThumb.style.width = `${w}px`;
      this.scrollThumb.style.transform = `translateX(${Math.round((trackW - w) * (ul.scrollLeft / max))}px)`;
    }

    spacer() {
      const h = DESKTOP.matches ? this.offsetHeight + 20 : this.head.offsetHeight + this.progress.offsetHeight;
      document.documentElement.style.setProperty('--bb-tray-h', `${h}px`);
    }

    setOpen(open, byUser) {
      this.open = !!open;
      this.classList.toggle('bb-tray--open', this.open);
      this.toggleBtn.setAttribute('aria-expanded', String(this.open));
      this.toggleBtn.setAttribute('aria-label', this.open ? 'Hide your bundle' : 'Show your bundle');
      store.set('bb-tray', this.open ? 'open' : 'closed');
      if (byUser && this.open) track('bundle_tray_opened');
    }

    onAdded() {
      // Mobile: open the bar on the first add of the session so the shopper sees the bundle fill.
      if (!DESKTOP.matches && !this.open && !store.get('bb-auto')) {
        this.setOpen(true);
        store.set('bb-auto', '1');
      }
      if (state.count >= 4) requestAnimationFrame(() => this.slots.scrollTo({ left: this.slots.scrollWidth, behavior: reduced() ? 'auto' : 'smooth' }));
    }

    arrange(units) {
      const paid = units.filter((u) => !u.free);
      const free = units.filter((u) => u.free);
      const out = [];
      while (paid.length || free.length) out.push(...paid.splice(0, 2), ...free.splice(0, 2));
      return out;
    }

    render(announce) {
      const n = state.count;
      const chip = `<span class="bb-chip">${COPY.free}</span>`;
      const slot = (u) => `<li class="bb-slot${u.free ? ' bb-slot--free' : ''}" data-key="${esc(u.key)}"><span class="bb-slot__media">${u.image ? `<img src="${esc(sized(u.image, 160))}" alt="" width="80" height="80" loading="lazy">` : ''}<button type="button" class="bb-slot__rm" data-key="${esc(u.key)}" aria-label="Remove one ${esc(u.title)}">${ICON.trash}</button>${u.free ? chip : ''}</span><span class="bb-slot__title">${esc(u.title)}</span></li>`;
      const empty = (free) => `<li class="bb-slot bb-slot--empty" aria-hidden="true"><span class="bb-slot__media">${ICON.add}${free ? chip : ''}</span></li>`;
      // Under 4 units the bar "promises" the deal: slots 3 and 4 always read FREE.
      const promise = n < 4;
      const list = this.arrange(state.units).map((u, i) => slot(promise ? { ...u, free: i >= 2 } : u));
      if (promise) for (let i = n; i < 4; i++) list.push(empty(i >= 2));
      else list.push(empty(false));
      const activeKey = document.activeElement?.closest?.('.bb-slot__rm')?.dataset.key;
      this.slots.innerHTML = list.join('');
      this.slots.classList.toggle('bb-slots--fit', promise);
      if (activeKey) (this.slots.querySelector(`.bb-slot__rm[data-key="${CSS.escape(activeKey)}"]`) || this.toggleBtn).focus();
      this.countEl.textContent = `${n} Item${n === 1 ? '' : 's'} Selected`;
      const filled = n ? ((n - 1) % 4) + 1 : 0;
      this.segs.forEach((s, i) => s.classList.toggle('is-on', i < filled));
      this.origEl.hidden = !(state.orig > state.fin);
      this.origEl.textContent = money(state.orig);
      this.finEl.textContent = money(state.fin);
      const cta = this.summary.querySelector('.bb-cta');
      if (n && cta.tagName !== 'A') cta.outerHTML = `<a class="bb-cta" href="${esc(window.routes?.cart_url || '/cart')}">${COPY.viewCart}</a>`;
      else if (!n && cta.tagName === 'A') cta.outerHTML = `<button type="button" class="bb-cta" disabled>${COPY.empty}</button>`;
      if (announce) {
        const freeCount = state.units.filter((u) => u.free).length;
        this.live.textContent = `${n} item${n === 1 ? '' : 's'} in your bundle${freeCount ? `, ${freeCount} free` : ''}.`;
      }
      this.spacer();
      this.syncScroll();
    }
  }

  /* ---------------- Boot ---------------- */
  const listen = () => {
    document.addEventListener('cart:updated', (e) => {
      const c = e.detail?.cart;
      if (isCartShape(c)) {
        state.seeded = true;
        setTimeout(() => { state.seeded = false; }, 0);
        setCart(c);
      } else {
        schedulePull();
      }
    });
    document.addEventListener('cart:refresh', () => { if (!state.seeded) schedulePull(); });
    window.addEventListener('pageshow', (e) => { if (e.persisted) schedulePull(); });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && Date.now() - state.lastSync > 5000) schedulePull();
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (ev?.source === 'bundle-builder') return;
        if (isCartShape(ev?.cartData)) setCart(ev.cartData);
        else schedulePull();
      });
    }
  };

  const init = () => {
    if (!document.querySelector('.bb-section')) return;
    if (!customElements.get('bundle-builder-tray')) customElements.define('bundle-builder-tray', BundleBuilderTray);
    Device.init();
    Grid.applyAppMembersOnly();
    // facets.js replaces the grid on filter/sort changes: re-apply app members-only and re-sync devices.
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(() => {
        Grid.applyAppMembersOnly();
        Device.sync();
      }).observe(container, { childList: true });
    }
    listen();
    pull();
  };

  window.BundleBuilder = { pull };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
